module.exports = __webpack_public_path__ + "static/media/btnchart.5e0eb7f8.png";